import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/down-icon.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-741d6d64")

_pushScopeId("data-v-741d6d64")
const _hoisted_1 = {
  class: "data-table-design",
  "data-id": "result-section"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row justify-content-center" }
const _hoisted_4 = { class: "col-lg-10" }
const _hoisted_5 = { class: "datatable-wrap" }
const _hoisted_6 = { class: "advance-search-cover" }
const _hoisted_7 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M487.976 0H24.028C2.71 0-8.047 25.866 7.058 40.971L192 225.941V432c0 7.831 3.821 15.17 10.237 19.662l80 55.98C298.02 518.69 320 507.493 320 487.98V225.941l184.947-184.97C520.021 25.896 509.338 0 487.976 0z" })
], -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "reset-icon" }, [
  /*#__PURE__*/_createVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, [
    /*#__PURE__*/_createVNode("path", { d: "M256.455 8c66.269.119 126.437 26.233 170.859 68.685l35.715-35.715C478.149 25.851 504 36.559 504 57.941V192c0 13.255-10.745 24-24 24H345.941c-21.382 0-32.09-25.851-16.971-40.971l41.75-41.75c-30.864-28.899-70.801-44.907-113.23-45.273-92.398-.798-170.283 73.977-169.484 169.442C88.764 348.009 162.184 424 256 424c41.127 0 79.997-14.678 110.629-41.556 4.743-4.161 11.906-3.908 16.368.553l39.662 39.662c4.872 4.872 4.631 12.815-.482 17.433C378.202 479.813 319.926 504 256 504 119.034 504 8.001 392.967 8 256.002 7.999 119.193 119.646 7.755 256.455 8z" })
  ])
], -1)
const _hoisted_9 = { class: "custom-tabs-label" }
const _hoisted_10 = { class: "badge-tabs" }
const _hoisted_11 = {
  class: "fa fa-spinner icon-spinner",
  "aria-hidden": "true"
}
const _hoisted_12 = { class: "inner_option_area" }
const _hoisted_13 = { class: "left_items_filter" }
const _hoisted_14 = { class: "options_section" }
const _hoisted_15 = /*#__PURE__*/_createVNode("span", null, null, -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("span", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("span", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("span", null, null, -1)
const _hoisted_19 = { class: "rt-filter-items" }
const _hoisted_20 = { class: "form-sec" }
const _hoisted_21 = { class: "form-sec" }
const _hoisted_22 = /*#__PURE__*/_createVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_23 = { class: "filter_section" }
const _hoisted_24 = { class: "datatable-header" }
const _hoisted_25 = { class: "datatable-sorting" }
const _hoisted_26 = { class: "total-view-box select-box" }
const _hoisted_27 = /*#__PURE__*/_createVNode("img", {
  class: "down-arrow-img",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_28 = { class: "table-holder" }
const _hoisted_29 = { "data-id": "person-table" }
const _hoisted_30 = {
  key: 0,
  class: "noResult"
}
const _hoisted_31 = { colspan: "5" }
const _hoisted_32 = {
  key: 0,
  class: "block pagination-box"
}
const _hoisted_33 = { class: "block pagination" }
const _hoisted_34 = {
  key: 1,
  class: "pagenumber-text"
}
const _hoisted_35 = { class: "custom-tabs-label" }
const _hoisted_36 = { class: "badge-tabs" }
const _hoisted_37 = {
  class: "fa fa-spinner icon-spinner",
  "aria-hidden": "true"
}
const _hoisted_38 = { class: "filter_section" }
const _hoisted_39 = { class: "datatable-header" }
const _hoisted_40 = { class: "datatable-sorting" }
const _hoisted_41 = { class: "total-view-box select-box" }
const _hoisted_42 = /*#__PURE__*/_createVNode("img", {
  class: "down-arrow-img",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_43 = { class: "table-holder" }
const _hoisted_44 = { "data-id": "company-table" }
const _hoisted_45 = {
  key: 0,
  class: "noResult"
}
const _hoisted_46 = { colspan: "5" }
const _hoisted_47 = {
  key: 0,
  class: "block pagination-box"
}
const _hoisted_48 = { class: "block pagination" }
const _hoisted_49 = {
  key: 1,
  class: "pagenumber-text"
}
const _hoisted_50 = /*#__PURE__*/_createVNode("div", null, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_person_advance_search = _resolveComponent("person-advance-search")
  const _component_WordHighlighter = _resolveComponent("WordHighlighter")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")
  const _component_company_advance_search = _resolveComponent("company-advance-search")
  const _component_el_tabs = _resolveComponent("el-tabs")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", {
                class: "advanced_search_section",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleAdvancedFilter()))
              }, [
                _createVNode("h3", null, _toDisplayString(_ctx.$t("default.button.advanced_search")), 1),
                _createVNode("span", {
                  class: ["funnel_icon", { active: _ctx.isFilterActive[_ctx.activeTab] }],
                  "data-toggle": "tooltip",
                  title: _ctx.$t('default.button.advanced_search')
                }, [
                  _hoisted_7
                ], 10, ["title"])
              ]),
              _createVNode("div", {
                class: "global-reset",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.resetQuickFilter(true))),
                "data-toggle": "tooltip",
                title: _ctx.$t('default.label.reset')
              }, [
                _hoisted_8
              ], 8, ["title"])
            ]),
            _createVNode(_component_el_tabs, {
              type: "card",
              modelValue: _ctx.activeTab,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.activeTab = $event)),
              onTabClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.onTabSelect($event)))
            }, {
              default: _withId(() => [
                (_ctx.tabDisplay.person)
                  ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                      key: 0,
                      name: _ctx.Config.CONSTANTS.PERSON
                    }, {
                      label: _withId(() => [
                        _createVNode("span", _hoisted_9, [
                          _createVNode("span", null, [
                            _createTextVNode(_toDisplayString(_ctx.$t("default.label.person_result")) + " ", 1),
                            _createVNode("span", _hoisted_10, [
                              _withDirectives(_createVNode("i", _hoisted_11, null, 512), [
                                [_vShow, 
                            _ctx.canShowCountLoader(_ctx.result?.person?.displayCount)
                          ]
                              ]),
                              _createTextVNode(_toDisplayString(_ctx.result?.person?.displayCount), 1)
                            ])
                          ])
                        ])
                      ]),
                      default: _withId(() => [
                        _createVNode("div", _hoisted_12, [
                          _createVNode("div", _hoisted_13, [
                            _createVNode("h4", null, _toDisplayString(_ctx.$t("default.label.sort_by")) + ":", 1),
                            _createVNode("div", _hoisted_14, [
                              _createVNode("div", {
                                class: ["single_option", { active: _ctx.quickFilter.isFemale }],
                                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onFilterChanged(_ctx.CONSTANTS.IS_FEMALE)))
                              }, [
                                _hoisted_15,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t("default.search_form.female")), 1)
                              ], 2),
                              _createVNode("div", {
                                class: ["single_option", { active: _ctx.quickFilter.isMale }],
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onFilterChanged(_ctx.CONSTANTS.IS_MALE)))
                              }, [
                                _hoisted_16,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t("default.search_form.male")), 1)
                              ], 2),
                              _createVNode("div", {
                                class: ["single_option", { active: _ctx.quickFilter.is_married }],
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onFilterChanged(_ctx.CONSTANTS.IS_MARRIED)))
                              }, [
                                _hoisted_17,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t("default.search_form.married")), 1)
                              ], 2),
                              _createVNode("div", {
                                class: ["single_option", { active: _ctx.quickFilter.company_involvement }],
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onFilterChanged(_ctx.CONSTANTS.COMPANY_INVOLVEMENT)))
                              }, [
                                _hoisted_18,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t("default.select_options.company_involvement")), 1)
                              ], 2)
                            ])
                          ]),
                          _createVNode("div", _hoisted_19, [
                            _createTextVNode(_toDisplayString(_ctx.$t("default.label.age_from")) + " ", 1),
                            _createVNode("span", _hoisted_20, [
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                onKeypress: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onAgeKeyPress && _ctx.onAgeKeyPress(...args))),
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.quickFilter.minimum_age = $event))
                              }, null, 544), [
                                [_vModelText, _ctx.quickFilter.minimum_age]
                              ])
                            ]),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("default.label.to")) + " ", 1),
                            _createVNode("span", _hoisted_21, [
                              _withDirectives(_createVNode("input", {
                                type: "text",
                                onKeypress: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onAgeKeyPress && _ctx.onAgeKeyPress(...args))),
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.quickFilter.maximum_age = $event))
                              }, null, 544), [
                                [_vModelText, _ctx.quickFilter.maximum_age]
                              ])
                            ]),
                            _createVNode("button", {
                              type: "button",
                              class: "apply-btn",
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onAgeFilterApply())),
                              "data-toggle": "tooltip",
                              title: _ctx.$t('default.search_form.search')
                            }, [
                              _hoisted_22
                            ], 8, ["title"])
                          ])
                        ]),
                        _withDirectives(_createVNode("div", _hoisted_23, [
                          _createVNode(_component_person_advance_search, { page: "result" })
                        ], 512), [
                          [_vShow, _ctx.isAdvancedSearch]
                        ]),
                        _createVNode("div", _hoisted_24, [
                          _createVNode("div", _hoisted_25, [
                            _createVNode("span", null, _toDisplayString(_ctx.$t("default.result_page.show_page_count")), 1),
                            _createVNode("div", _hoisted_26, [
                              _hoisted_27,
                              (_ctx.apiService)
                                ? _withDirectives((_openBlock(), _createBlock("select", {
                                    key: 0,
                                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.result.person.perPageCount = $event)),
                                    onChange: _cache[13] || (_cache[13] = ($event: any) => (_ctx.handlePerPageChange(_ctx.CONSTANTS.PERSON)))
                                  }, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tableSizeList, (option) => {
                                      return (_openBlock(), _createBlock("option", {
                                        value: option,
                                        key: option
                                      }, _toDisplayString(option), 9, ["value"]))
                                    }), 128))
                                  ], 544)), [
                                    [_vModelSelect, _ctx.result.person.perPageCount]
                                  ])
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode("span", null, _toDisplayString(_ctx.$t("default.result_page.count")), 1)
                          ])
                        ]),
                        _createVNode("div", _hoisted_28, [
                          _createVNode("table", _hoisted_29, [
                            _createVNode("thead", null, [
                              _createVNode("tr", null, [
                                _createVNode("th", null, _toDisplayString(_ctx.$t("default.table.ssn")), 1),
                                _createVNode("th", null, _toDisplayString(_ctx.$t("default.table.first_name")), 1),
                                _createVNode("th", null, _toDisplayString(_ctx.$t("default.table.last_name")), 1),
                                _createVNode("th", null, _toDisplayString(_ctx.$t("default.table.street")), 1),
                                _createVNode("th", null, _toDisplayString(_ctx.$t("default.table.city")), 1)
                              ])
                            ]),
                            _createVNode("tbody", null, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.result.person.result, (item) => {
                                return (_openBlock(), _createBlock("tr", {
                                  key: item.ssn,
                                  onClick: ($event: any) => (_ctx.onRowClick(item.ssn, _ctx.CONSTANTS.PERSON))
                                }, [
                                  _createVNode("td", null, _toDisplayString(item.display_ssn), 1),
                                  _createVNode("td", null, [
                                    _createVNode(_component_WordHighlighter, {
                                      query: item.given_name,
                                      highlightTag: "strong"
                                    }, {
                                      default: _withId(() => [
                                        _createTextVNode(_toDisplayString(item.first_name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["query"])
                                  ]),
                                  _createVNode("td", null, [
                                    _createVNode(_component_WordHighlighter, {
                                      query: item.given_name,
                                      highlightTag: "strong"
                                    }, {
                                      default: _withId(() => [
                                        _createTextVNode(_toDisplayString(item.last_name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["query"])
                                  ]),
                                  _createVNode("td", null, _toDisplayString(item.street), 1),
                                  _createVNode("td", null, _toDisplayString(item.city), 1)
                                ], 8, ["onClick"]))
                              }), 128))
                            ]),
                            (
                        (!_ctx.result.person.result || !_ctx.result.person.result.length ) && !_ctx.apiService.isFetching
                      )
                              ? (_openBlock(), _createBlock("tr", _hoisted_30, [
                                  _createVNode("td", _hoisted_31, _toDisplayString(_ctx.$t("default.alert.no_result")), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        (_ctx.result.person.result.length > 0)
                          ? (_openBlock(), _createBlock("div", _hoisted_32, [
                              _createVNode("div", _hoisted_33, [
                                _createVNode(_component_el_pagination, {
                                  onCurrentChange: _cache[14] || (_cache[14] = ($event: any) => (
                        _ctx.currentPageChangeHandler(_ctx.CONSTANTS.PERSON)
                      )),
                                  currentPage: _ctx.result.person.currentPageNumber,
                                  "onUpdate:currentPage": _cache[15] || (_cache[15] = ($event: any) => (_ctx.result.person.currentPageNumber = $event)),
                                  layout: _ctx.paginationLayout,
                                  "page-size": _ctx.result.person.perPageCount,
                                  total: _ctx.result.person.totalResults,
                                  "prev-text": _ctx.prevButtonText,
                                  "next-text": _ctx.nextButtonText
                                }, null, 8, ["currentPage", "layout", "page-size", "total", "prev-text", "next-text"])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.result.person.result.length > 0)
                          ? (_openBlock(), _createBlock("div", _hoisted_34, [
                              _createVNode("p", null, _toDisplayString(_ctx.$t("default.result_page.footer", {
                        firstRowIndex:
                          (_ctx.result.person.currentPageNumber - 1) *
                            _ctx.result.person.perPageCount +
                          1,
                        lastRowIndex: _ctx.getLastRowIndex(
                          _ctx.result.person.perPageCount,
                          _ctx.result.person.currentPageNumber,
                          _ctx.result.person.totalResults
                        ),
                        totalResultCount: _ctx.result.person.totalResults,
                      })), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["name"]))
                  : _createCommentVNode("", true),
                (_ctx.tabDisplay.company)
                  ? (_openBlock(), _createBlock(_component_el_tab_pane, {
                      key: 1,
                      name: _ctx.Config.CONSTANTS.COMPANY
                    }, {
                      label: _withId(() => [
                        _createVNode("span", _hoisted_35, [
                          _createVNode("span", null, [
                            _createTextVNode(_toDisplayString(_ctx.$t("default.label.company_result")) + " ", 1),
                            _createVNode("span", _hoisted_36, [
                              _withDirectives(_createVNode("i", _hoisted_37, null, 512), [
                                [_vShow, 
                            _ctx.canShowCountLoader(_ctx.result?.company?.displayCount)
                          ]
                              ]),
                              _createTextVNode(_toDisplayString(_ctx.result?.company?.displayCount), 1)
                            ])
                          ])
                        ])
                      ]),
                      default: _withId(() => [
                        _withDirectives(_createVNode("div", _hoisted_38, [
                          _createVNode(_component_company_advance_search, { page: "result" })
                        ], 512), [
                          [_vShow, _ctx.isAdvancedSearch]
                        ]),
                        _createVNode("div", _hoisted_39, [
                          _createVNode("div", _hoisted_40, [
                            _createVNode("span", null, _toDisplayString(_ctx.$t("default.result_page.show_page_count")), 1),
                            _createVNode("div", _hoisted_41, [
                              _hoisted_42,
                              (_ctx.apiService)
                                ? _withDirectives((_openBlock(), _createBlock("select", {
                                    key: 0,
                                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.result.company.perPageCount = $event)),
                                    onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.handlePerPageChange(_ctx.CONSTANTS.COMPANY)))
                                  }, [
                                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tableSizeList, (option) => {
                                      return (_openBlock(), _createBlock("option", {
                                        value: option,
                                        key: option
                                      }, _toDisplayString(option), 9, ["value"]))
                                    }), 128))
                                  ], 544)), [
                                    [_vModelSelect, _ctx.result.company.perPageCount]
                                  ])
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode("span", null, _toDisplayString(_ctx.$t("default.result_page.count")), 1)
                          ])
                        ]),
                        _createVNode("div", _hoisted_43, [
                          _createVNode("table", _hoisted_44, [
                            _createVNode("thead", null, [
                              _createVNode("tr", null, [
                                _createVNode("th", null, _toDisplayString(_ctx.$t("default.table.org_id")), 1),
                                _createVNode("th", null, _toDisplayString(_ctx.$t("default.table.company_name")), 1),
                                _createVNode("th", null, _toDisplayString(_ctx.$t("default.table.company_code")), 1),
                                _createVNode("th", null, _toDisplayString(_ctx.$t("default.table.street")), 1),
                                _createVNode("th", null, _toDisplayString(_ctx.$t("default.table.city")), 1)
                              ])
                            ]),
                            _createVNode("tbody", null, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.result.company.result, (item) => {
                                return (_openBlock(), _createBlock("tr", {
                                  key: item.org_id,
                                  onClick: ($event: any) => (_ctx.onRowClick(item.org_id, _ctx.CONSTANTS.COMPANY))
                                }, [
                                  _createVNode("td", null, _toDisplayString(item.display_org_id), 1),
                                  _createVNode("td", null, _toDisplayString(item.company_name), 1),
                                  _createVNode("td", null, _toDisplayString(item.company_code), 1),
                                  _createVNode("td", null, _toDisplayString(item.street), 1),
                                  _createVNode("td", null, _toDisplayString(item.city), 1)
                                ], 8, ["onClick"]))
                              }), 128))
                            ]),
                            (
                        (!_ctx.result.company.result || !_ctx.result.company.result.length) && !_ctx.apiService.isFetching
                      )
                              ? (_openBlock(), _createBlock("tr", _hoisted_45, [
                                  _createVNode("td", _hoisted_46, _toDisplayString(_ctx.$t("default.alert.no_result")), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        (_ctx.result.company.result.length > 0)
                          ? (_openBlock(), _createBlock("div", _hoisted_47, [
                              _createVNode("div", _hoisted_48, [
                                _createVNode(_component_el_pagination, {
                                  onCurrentChange: _cache[18] || (_cache[18] = ($event: any) => (
                        _ctx.currentPageChangeHandler(_ctx.CONSTANTS.COMPANY)
                      )),
                                  currentPage: _ctx.result.company.currentPageNumber,
                                  "onUpdate:currentPage": _cache[19] || (_cache[19] = ($event: any) => (_ctx.result.company.currentPageNumber = $event)),
                                  layout: _ctx.paginationLayout,
                                  "page-size": _ctx.result.company.perPageCount,
                                  total: _ctx.result.company.totalResults,
                                  "prev-text": _ctx.prevButtonText,
                                  "next-text": _ctx.nextButtonText
                                }, null, 8, ["currentPage", "layout", "page-size", "total", "prev-text", "next-text"])
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.result.company.result.length > 0)
                          ? (_openBlock(), _createBlock("div", _hoisted_49, [
                              _createVNode("p", null, _toDisplayString(_ctx.$t("default.result_page.footer", {
                        firstRowIndex:
                          (_ctx.result.company.currentPageNumber - 1) *
                            _ctx.result.company.perPageCount +
                          1,
                        lastRowIndex: _ctx.getLastRowIndex(
                          _ctx.result.company.perPageCount,
                          _ctx.result.company.currentPageNumber,
                          _ctx.result.company.totalResults
                        ),
                        totalResultCount: _ctx.result.company.totalResults,
                      })), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["name"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _hoisted_50
          ])
        ])
      ])
    ])
  ]))
})